var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9 1.5a7.5 7.5 0 1 1 -7.5 7.5 7.509 7.509 0 0 1 7.5-7.5zm0-1.5a9 9 0 1 0 9 9 9 9 0 0 0 -9-9zm.75 9v-4.5h-1.5v6h5.25v-1.5z",
    fill: "#9cdbd9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.50efe2102e5255817402c17bec03f3fb.svg";
export { ForwardRef as ReactComponent };